import { render, staticRenderFns } from "./PackageVariantClosedRemove.vue?vue&type=template&id=08e9008b"
import script from "./PackageVariantClosedRemove.vue?vue&type=script&lang=js"
export * from "./PackageVariantClosedRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports